import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import logoIzquierdo from '@/assets/logo_durango.png'
import logoDerecho from '@/assets/logo_salud.jpg'

function getBase64FromImage(imgUrl) {
  return new Promise((resolve) => {
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.onload = () => {
      const canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0)
      resolve(canvas.toDataURL('image/png'))
    }
    img.src = imgUrl
  })
}

function formatearFecha(fecha) {
  return new Intl.DateTimeFormat('es-MX', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  }).format(new Date(fecha))
}

function formatMayusculas(palabras) {
  return palabras.toUpperCase()
}

function formatearFechaHora(fecha) {
  return new Intl.DateTimeFormat('es-MX', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(new Date(fecha))
}

function campo(doc, label, value, x, y, width, minHeight = 10) {
  const text = value || ''
  const textLines = doc.splitTextToSize(text, width - 2)
  const boxHeight = Math.max(minHeight, textLines.length * 3.4 + 2)

  const pageHeight = doc.internal.pageSize.height
  const marginBottom = 25

  if (y + boxHeight + marginBottom > pageHeight) {
    doc.addPage()
    y = 20
  }

  // Label
  doc.setFontSize(7)
  doc.setFont('helvetica', 'bold')
  doc.setTextColor(0, 0, 0)
  doc.text(label, x, y)

  // Texto
  doc.setFontSize(8)
  doc.setTextColor(78, 78, 78)
  doc.setFont('helvetica', 'normal')


  // Caja gris
  doc.setFillColor(245, 245, 245)
  doc.rect(x, y + 1, width, boxHeight, 'F')

  // Texto
  doc.text(textLines, x + 2, y + 5)
  doc.setDrawColor(208, 208, 208)
  doc.setLineWidth(0.3)
  doc.line(x, y + 1 + boxHeight, x + width, y + 1 + boxHeight)

  return y + boxHeight + 6
}

function drawRow(doc, startY, columns) {
  const colWidth = columns.length === 1 ? FULL_WIDTH : HALF

  columns.forEach((col, i) => {
    autoTable(doc, {
      startY,
      head: [[{
        content: col.label,
        styles: { halign: 'left', fontStyle: 'bold', fontSize: 9 }
      }]],
      body:       [[col.value ?? '']],
      styles:     BASE_STYLES,
      headStyles: BASE_HEAD_STYLES,
      margin:     { left: LEFT + i * (colWidth + COL_GAP) },
      tableWidth: colWidth,
    })
  })

  return doc.lastAutoTable.finalY + ROW_GAP
}
function tituloSeccion(doc, texto, y) {
  doc.setFontSize(9)
  doc.setFont('helvetica', 'bold')
  doc.setTextColor(0)
  doc.text(texto.toUpperCase(), 15, y)

  doc.setDrawColor(7, 88, 144)
  doc.setLineWidth(0.4)
  doc.line(15, y + 2, 200, y + 2)

  return y + 8
}

async function generarHojaPsicologia(paciente, consulta, cedula) {
  const doc = new jsPDF('p', 'mm', 'letter')
  const pageWidth = doc.internal.pageSize.getWidth()


  const logo1 = await getBase64FromImage(logoIzquierdo)
  const logo2 = await getBase64FromImage(logoDerecho)

  doc.addImage(logo1, 'PNG', 14, 5, 45, 30)
  doc.addImage(logo2, 'PNG', pageWidth - 60, 5, 45, 30)

  doc.setFontSize(11)
  doc.setFont('helvetica', 'bold')
  doc.text('SERVICIOS DE SALUD DEL ESTADO DE DURANGO', pageWidth / 2, 25, { align: 'center' })
  doc.setFontSize(12)
  doc.text('HOJA CLÍNICA PSICOLOGÍA', pageWidth / 2, 30, { align: 'center' })

  let y = 38

  autoTable(doc, {
    startY: y,
    head: [[
      {
        content: 'Datos Generales',
        colSpan: 4,
        styles: { halign: 'center', fontStyle: 'bold', fontSize: 10 }
      }
    ]],
    body: [
      // Fila completa
      [
        { content: 'Nombre', styles: { fontStyle: 'bold', fillColor: [230, 230, 230] } },
        { content: consulta.nombre, colSpan: 3 }
      ],
      // Dos campos por fila
      [
        { content: 'Edad',               styles: { fontStyle: 'bold', fillColor: [230, 230, 230] } },
        { content: consulta.edad },
        { content: 'Fecha de Nacimiento', styles: { fontStyle: 'bold', fillColor: [230, 230, 230] } },
        { content: formatearFecha(paciente.fechaNacimiento) }
      ],
      [
        { content: 'Escolaridad', styles: { fontStyle: 'bold', fillColor: [230, 230, 230] } },
        { content: consulta.escolaridad },
        { content: 'Ocupación',   styles: { fontStyle: 'bold', fillColor: [230, 230, 230] } },
        { content: consulta.ocupacion }
      ],
      // Fila completa
      [
        { content: 'Domicilio', styles: { fontStyle: 'bold', fillColor: [230, 230, 230] } },
        { content: consulta.domicilio, colSpan: 3 }
      ],
      [
        { content: 'Cd. de origen',     styles: { fontStyle: 'bold', fillColor: [230, 230, 230] } },
        { content: consulta.cdOrigen },
        { content: 'Cd. de residencia', styles: { fontStyle: 'bold', fillColor: [230, 230, 230] } },
        { content: consulta.cdResidencia }
      ],
      [
        { content: 'Estado Civil', styles: { fontStyle: 'bold', fillColor: [230, 230, 230] } },
        { content: consulta.estadoCivil },
        { content: 'Vive con',    styles: { fontStyle: 'bold', fillColor: [230, 230, 230] } },
        { content: consulta.viveCon }
      ],
      [
        { content: 'Teléfono', styles: { fontStyle: 'bold', fillColor: [230, 230, 230] } },
        { content: consulta.telefono },
        { content: 'E-Mail',   styles: { fontStyle: 'bold', fillColor: [230, 230, 230] } },
        { content: consulta.email }
      ],
      [
        { content: 'Fecha de Ingreso', styles: { fontStyle: 'bold', fillColor: [230, 230, 230] } },
        { content: consulta.fechaIngreso },
        { content: 'Fecha de Egreso',  styles: { fontStyle: 'bold', fillColor: [230, 230, 230] } },
        { content: consulta.fechaEgreso }
      ],
      // Filas completas
      [
        { content: 'Alergias', styles: { fontStyle: 'bold', fillColor: [230, 230, 230] } },
        { content: consulta.alergias, colSpan: 3 }
      ],
      [
        { content: '¿Padece alguna enfermedad?', styles: { fontStyle: 'bold', fillColor: [230, 230, 230] } },
        { content: consulta.enfermedad, colSpan: 3 }
      ],
    ],
    styles: {
      fontSize: 8,
      cellPadding: 1.5,
      lineWidth: 0.1,
    },
    headStyles: {
      fillColor: [200, 200, 200],
      textColor: [0, 0, 0],
      fontStyle: 'bold',
    },
    columnStyles: {
      0: { cellWidth: 35 },  // etiqueta izquierda
      //1: { cellWidth: 20 },  // valor izquierdo  ← ajusta según contenido
      2: { cellWidth: 35 },  // etiqueta derecha
     // 3: { cellWidth: 20 },  // valor derecho
    },
    margin: { left: 15 , right:15},
  })
  
  y = doc.lastAutoTable.finalY += 3;

autoTable(doc, {
  startY: y,
  margin: {
      left: 15   
  },
  headStyles: {
      fillColor: [230, 230, 230],
      textColor: [0, 0, 0]
  },
  styles: {
      fontSize: 6,
      cellPadding: 1
  },
  head: [
      [
          {
              content: "Observaciones",
              styles: {
                  halign: "center",
                  fontStyle: "bold",
                  fontSize: 10
              }
          }
      ]
  ],
  body: [
      [consulta.observaciones],
  ],
  columnStyles: {
      0: { halign: "left" },
  },
})
y = doc.lastAutoTable.finalY += 3;

autoTable(doc, {
  startY: y,
  margin: {
      left: 15, right: 15   
  },
  headStyles: {
      fillColor: [230, 230, 230],
      textColor: [0, 0, 0]
  },
  styles: {
      fontSize: 8,
      cellPadding: 1
  },
  head: [
      [
          {
              content: "Motivo de Consulta",
              styles: {
                  halign: "center",
                  fontStyle: "bold",
                  fontSize: 10
              }
          }
      ]
  ],
  body: [
      [consulta.motivoConsulta],
  ],
  columnStyles: {
      0: { halign: "left" },
  },
})

y = doc.lastAutoTable.finalY += 3;

autoTable(doc, {
  startY: y,
  margin: {
      left: 15, right: 15   
  },
  headStyles: {
      fillColor: [230, 230, 230],
      textColor: [0, 0, 0]
  },
  styles: {
      fontSize: 8,
      cellPadding: 1
  },
  head: [
      [
          {
              content: "Problemas o padecimiento actual",
              styles: {
                  halign: "center",
                  fontStyle: "bold",
                  fontSize: 10
              }
          }
      ]
  ],
  body: [
      [consulta.problemaActual],
  ],
  columnStyles: {
      0: { halign: "left" },
  },
})
  
y = doc.lastAutoTable.finalY += 3;
 
autoTable(doc, {
  startY: y,
  margin: {
      left: 15, right: 15   
  },
  headStyles: {
      fillColor: [230, 230, 230],
      textColor: [0, 0, 0]
  },
  styles: {
      fontSize: 8,
      cellPadding: 1
  },
  head: [
      [
          {
              content: "Objetivos del paciente",
              styles: {
                  halign: "center",
                  fontStyle: "bold",
                  fontSize: 10
              }
          }
      ]
  ],
  body: [
      [consulta.objetivosPaciente],
  ],
  columnStyles: {
      0: { halign: "left" },
  },
})

y = doc.lastAutoTable.finalY += 3;

autoTable(doc, {
  startY: y,
  margin: {
      left: 15, right: 15   
  },
  headStyles: {
      fillColor: [230, 230, 230],
      textColor: [0, 0, 0]
  },
  styles: {
      fontSize: 8,
      cellPadding: 1
  },
  head: [
      [
          {
              content: "Objetivos del Psicólogo",
              styles: {
                  halign: "center",
                  fontStyle: "bold",
                  fontSize: 10
              }
          }
      ]
  ],
  body: [
      [consulta.objetivosTerapeuta],
  ],
  columnStyles: {
      0: { halign: "left" },
  },
})
  
y = doc.lastAutoTable.finalY += 3;

autoTable(doc, {
  startY: y,
  margin: {
      left: 15, right: 15   
  },
  headStyles: {
      fillColor: [230, 230, 230],
      textColor: [0, 0, 0]
  },
  styles: {
      fontSize: 8,
      cellPadding: 1
  },
  head: [
      [
          {
              content: "Situación familiar, laboral, social y económica",
              styles: {
                  halign: "center",
                  fontStyle: "bold",
                  fontSize: 10
              }
          }
      ]
  ],
  body: [
      [consulta.situacion],
  ],
  columnStyles: {
      0: { halign: "left" },
  },
})

y = doc.lastAutoTable.finalY += 3;

autoTable(doc, {
  startY: y,
  margin: {
      left: 15, right: 15   
  },
  headStyles: {
      fillColor: [230, 230, 230],
      textColor: [0, 0, 0]
  },
  styles: {
      fontSize: 8,
      cellPadding: 1
  },
  head: [
      [
          {
              content: "Antecedentes personales",
              styles: {
                  halign: "center",
                  fontStyle: "bold",
                  fontSize: 10
              }
          }
      ]
  ],
  body: [
      [consulta.antecedentesPersonales],
  ],
  columnStyles: {
      0: { halign: "left" },
  },
})
 
y = doc.lastAutoTable.finalY += 3;

autoTable(doc, {
  startY: y,
  margin: {
      left: 15, right: 15   
  },
  headStyles: {
      fillColor: [230, 230, 230],
      textColor: [0, 0, 0]
  },
  styles: {
      fontSize: 8,
      cellPadding: 1
  },
  head: [
      [
          {
              content: "Consumo de sustancias toxicas y problemas relacionadas",
              styles: {
                  halign: "center",
                  fontStyle: "bold",
                  fontSize: 10
              }
          }
      ]
  ],
  body: [
      [consulta.consumo],
  ],
  columnStyles: {
      0: { halign: "left" },
  },
})

y = doc.lastAutoTable.finalY += 3;

autoTable(doc, {
  startY: y,
  margin: {
      left: 15, right: 15   
  },
  headStyles: {
      fillColor: [230, 230, 230],
      textColor: [0, 0, 0]
  },
  styles: {
      fontSize: 8,
      cellPadding: 1
  },
  head: [
      [
          {
              content: "Antecedentes familiares",
              styles: {
                  halign: "center",
                  fontStyle: "bold",
                  fontSize: 10
              }
          }
      ]
  ],
  body: [
      [consulta.antecedentesFamiliares],
  ],
  columnStyles: {
      0: { halign: "left" },
  },
})
 
y = doc.lastAutoTable.finalY += 3;

autoTable(doc, {
  startY: y,
  margin: {
      left: 15, right: 15   
  },
  headStyles: {
      fillColor: [230, 230, 230],
      textColor: [0, 0, 0]
  },
  styles: {
      fontSize: 8,
      cellPadding: 1
  },
  head: [
      [
          {
              content: "Examen del estado mental",
              styles: {
                  halign: "center",
                  fontStyle: "bold",
                  fontSize: 10
              }
          }
      ]
  ],
  body: [
      [consulta.estadoMental],
  ],
  columnStyles: {
      0: { halign: "left" },
  },
})

y = doc.lastAutoTable.finalY += 3;

autoTable(doc, {
  startY: y,
  margin: {
      left: 15, right: 15   
  },
  headStyles: {
      fillColor: [230, 230, 230],
      textColor: [0, 0, 0]
  },
  styles: {
      fontSize: 8,
      cellPadding: 1
  },
  head: [
      [
          {
              content: "Temperamento o Caracter",
              styles: {
                  halign: "center",
                  fontStyle: "bold",
                  fontSize: 10
              }
          }
      ]
  ],
  body: [
      [consulta.temperamento],
  ],
  columnStyles: {
      0: { halign: "left" },
  },
})
 
y = doc.lastAutoTable.finalY += 3;

autoTable(doc, {
  startY: y,
  margin: {
      left: 15, right: 15   
  },
  headStyles: {
      fillColor: [230, 230, 230],
      textColor: [0, 0, 0]
  },
  styles: {
      fontSize: 8,
      cellPadding: 1
  },
  head: [
      [
          {
              content: "Examen y tratamientos preventivos",
              styles: {
                  halign: "center",
                  fontStyle: "bold",
                  fontSize: 10
              }
          }
      ]
  ],
  body: [
      [consulta.tratamientos],
  ],
  columnStyles: {
      0: { halign: "left" },
  },
})
   
y = doc.lastAutoTable.finalY += 3;

autoTable(doc, {
  startY: y,
  margin: {
      left: 15, right: 15   
  },
  headStyles: {
      fillColor: [230, 230, 230],
      textColor: [0, 0, 0]
  },
  styles: {
      fontSize: 8,
      cellPadding: 1
  },
  head: [
      [
          {
              content: "Observaciones Generales",
              styles: {
                  halign: "center",
                  fontStyle: "bold",
                  fontSize: 10
              }
          }
      ]
  ],
  body: [
      [consulta.antecedentesFamiliares],
  ],
  columnStyles: {
      0: { halign: "left" },
  },
})
y = doc.lastAutoTable.finalY += 3;

autoTable(doc, {
  startY: y,
  margin: {
      left: 15, right: 15   
  },
  headStyles: {
      fillColor: [230, 230, 230],
      textColor: [0, 0, 0]
  },
  styles: {
      fontSize: 8,
      cellPadding: 1
  },
  head: [
      [
          {
              content: "Impresión diagnostica",
              styles: {
                  halign: "center",
                  fontStyle: "bold",
                  fontSize: 10
              }
          }
      ]
  ],
  body: [
      [consulta.impresion],
  ],
  columnStyles: {
      0: { halign: "left" },
  },
})


y = doc.lastAutoTable.finalY += 3;

autoTable(doc, {
  startY: y,
  margin: {
      left: 15, right: 15   
  },
  headStyles: {
      fillColor: [230, 230, 230],
      textColor: [0, 0, 0]
  },
  styles: {
      fontSize: 8,
      cellPadding: 1
  },
  head: [
      [
          {
              content: "Indicaciones Terapeuticas",
              styles: {
                  halign: "center",
                  fontStyle: "bold",
                  fontSize: 10
              }
          }
      ]
  ],
  body: [
      [consulta.indicaciones],
  ],
  columnStyles: {
      0: { halign: "left" },
  },
})

y = doc.lastAutoTable.finalY += 3;
   

  const lineaY = y
  doc.setFontSize(10)
  doc.setFont('helvetica', 'bold')

  // doc.addImage(firma, 'PNG', pageWidth / 2 - 30, lineaY , 60, 30)

  doc.line(pageWidth / 2 - 30, lineaY + 30    , pageWidth / 2 + 30, lineaY + 30)
  doc.text(consulta.psicologo, pageWidth / 2, lineaY + 35, { align: 'center' })
  doc.text('NOMBRE Y FIRMA DEL PSICÓLOGO', pageWidth / 2, lineaY + 40, { align: 'center' })
  doc.text('CEDULA PROFESIONAL - ' + cedula, pageWidth / 2, lineaY + 45, { align: 'center' })

    const base64 = doc.output('datauristring')
    return base64
}
export { generarHojaPsicologia }